export default {
	noteFullName: 'Příjmení a jméno',
	noteDateCreated: 'Datum',
	noteContent: 'Vyjádření',
	addNote: 'Přidat poznámku',
};
